import React, { useEffect, useRef } from "react";
import { API, api } from "../lib/api";

// Resolve relative /api/banner-img URLs against the backend origin
function resolveSrc(url) {
  if (!url) return "";
  if (url.startsWith("http")) return url;
  if (url.startsWith("/api/")) return `${API.replace(/\/api$/, "")}${url}`;
  return url;
}

// Max container width per IAB format (keeps banners at their native size,
// centering them so a 300x250 doesn't stretch to 700px wide on desktop).
const IAB_MAX_W = {
  leaderboard: 728,
  medium_rectangle: 300,
  mobile: 320,
  billboard: 970,
};
// Short formats (mobile, leaderboard) need the "Publicidade" badge moved so it
// doesn't cover the CTA pill.
const SHORT_FORMATS = new Set(["mobile"]);

export const BannerAd = ({ banner, className = "" }) => {
  const fired = useRef(false);
  useEffect(() => {
    if (fired.current || !banner?.id) return;
    fired.current = true;
    api.post(`/banners/${banner.id}/impression`).catch(() => {});
  }, [banner?.id]);

  if (!banner) return null;
  const href = `${API}/banners/${banner.id}/go`;
  const maxW = IAB_MAX_W[banner.iab_format];
  const isShort = SHORT_FORMATS.has(banner.iab_format);

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer sponsored"
      data-testid={`banner-ad-${banner.id}`}
      style={maxW ? { maxWidth: maxW, marginInline: "auto" } : undefined}
      className={`block relative overflow-hidden rounded-3xl border border-border bg-card soft-shadow group ${className}`}
    >
      <img
        src={resolveSrc(banner.image_url)}
        alt={banner.title || "Publicidade"}
        loading="lazy"
        className="w-full h-auto max-h-full object-contain group-hover:scale-[1.02] transition-transform duration-500"
      />
      <span
        className={`absolute rounded-full bg-black/50 backdrop-blur-sm text-white text-[10px] font-semibold px-2 py-0.5 ${
          isShort ? "bottom-1 left-1" : "top-2 right-2"
        }`}
      >
        Publicidade
      </span>
    </a>
  );
};

export default BannerAd;
